import ICourierState from "./ICourierState";

const CourierReducers =  {
    SAVE_COURIERS:saveCouriers,
    SAVE_OPENED_ORDERS:saveOpenedOrders,
    SAVE_ORDER_HISTORY:saveOrderHistory
}

function saveCouriers(state:ICourierState, action:any) {
    return { ...state, ...{couriers:action.couriers} };

}
function saveOpenedOrders(state:ICourierState, action:any) {
    return { ...state, ...{openedOrders:action.openedOrders} };

}
function saveOrderHistory(state:ICourierState, action:any) {
    return { ...state, ...{orderHistory:action.orders} };

}

export default CourierReducers
